import { CheckOutlined } from '@ant-design/icons';
import { Button, Checkbox, Divider, Typography } from 'antd';
import { useContext, useState } from 'react';
import { DrawerContext } from '~/providers/DrawerProvider';
import message from '~/utils/message';
import PageContext from '../../context';
import BaseItemRow from '../BaseItemRow';
import { api, Order } from '@restaurant/api';

const ChecklistDrawer = ({
  order,
  onSuccess,
}: {
  order: Order;
  onSuccess: () => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState<boolean[][]>(() => {
    return order.batches.map((items) => {
      return items.map(({ isChecked }) => {
        return isChecked ?? false;
      });
    });
  });

  const onChange = ({
    value,
    batchIndex,
    itemIndex,
  }: {
    value: boolean;
    batchIndex: number;
    itemIndex: number;
  }) => {
    setChecked((prev) => {
      const newArray = [...prev];
      prev[batchIndex][itemIndex] = value;
      return newArray;
    });
  };

  const onCheckAll = () => {
    setChecked((prev) => {
      return prev.map((items) => items.map(() => true));
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await api.setOrderChecklist(order.orderId, checked);
      message.success('Berhasil checklist');
      onSuccess();
    } catch (e: any) {
      message.error('Gagal checklist: ' + e.message);
    }
    setLoading(false);
  };

  return (
    <div>
      <div style={{ paddingBottom: 150 }}>
        {order.batches.map((batch, batchIndex) => {
          return (
            <div key={`${batchIndex}`}>
              <div className="flex justify-between mx-4">
                <Typography.Text type="secondary">
                  {`#${batchIndex + 1}`}
                </Typography.Text>
              </div>
              {batch.map((item, itemIndex) => (
                <div
                  key={`${batchIndex}-${item.menuId}`}
                  className="flex items-baseline ml-4 cursor-pointer"
                  onClick={() => {
                    onChange({
                      value: !checked[batchIndex][itemIndex],
                      itemIndex,
                      batchIndex,
                    });
                  }}
                >
                  <Checkbox checked={checked[batchIndex][itemIndex]} />
                  <div className="flex-1">
                    <BaseItemRow item={item} />
                  </div>
                </div>
              ))}
              <Divider
                style={{
                  marginTop: 4,
                  marginBottom: 4,
                  backgroundColor: '#ddd',
                }}
              />
            </div>
          );
        })}
        <div className="px-4 mt-4">
          <Button onClick={onCheckAll} type="primary">
            Ceklist semua
          </Button>
        </div>
      </div>
      <div
        className="fixed w-full bottom-0 py-4 px-4 bg-white"
        style={{ boxShadow: '0px -35px 40px 12px white' }}
      >
        <Button
          block
          type="primary"
          size="large"
          onClick={handleSubmit}
          loading={loading}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

const useChecklistButton = ({ order }: { order: Order }) => {
  const { openDrawer } = useContext(DrawerContext);
  const { refresh } = useContext(PageContext);
  return {
    key: 'checklist',
    icon: <CheckOutlined />,
    text: 'Ceklist',
    onClick: () => {
      openDrawer(
        ({ closeDrawer }) => {
          const onSuccess = () => {
            closeDrawer();
            refresh();
          };

          return <ChecklistDrawer order={order} onSuccess={onSuccess} />;
        },
        {
          height: '90%',
          placement: 'bottom',
          closable: true,
          title: 'Checklist',
          bodyStyle: {
            padding: 0,
          },
          destroyOnClose: true,
        }
      );
    },
  };
};

export default useChecklistButton;
